export default __webpack_public_path__ + "static/media/react.f54352da.png";